import React, { useRef, useState } from "react";
import forwardArrow from "../../../../assets/images/forwardArrow.svg";
import { Typography } from "@mui/material";
import romRightExtension from "../../../../assets/images/romRightExtension.png";
import "./romTestModule.scss";
import { useDispatch } from "react-redux";
import {
  HOW_TO_TEST_RIGHT_EXTENSION,
  USER_LIST,
} from "../../../../routes/routerPath";
import { searchParams } from "../../../../utlis/helpers";
import { useNavigate } from "react-router-dom";
import { setVideoFile } from "../../../../state/actions/videoUploadAction";
import { infoPageItem } from "../../../../utlis/constants";
import FileUpload from "../videoSaved/FileUpload";
import UserDetailsHeader from "../../UserDetailsHeader";
import { pageLocale } from "../../../../utlis/locale";

const ROMRightExtension = () => {
  const storedTest = JSON.parse(sessionStorage.getItem("testMModule"));
  const getTestDetails = storedTest.find((e) => e.moduleId === 5);
  const [showItem, setShowItem] = useState(true);
  const statusOfTestTaken = sessionStorage.getItem("romStatus");
  const itemList = [...infoPageItem];
  const videoRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getInfo = JSON.parse(sessionStorage.getItem("testDescription"));
  const { how_to_test, record_upload } = pageLocale("testinfo");
  const { testUploadAlert } = pageLocale("common");
  const { right_leg, knee_extension, skip, right_extension_desc } =
    pageLocale("rom");
  const videoHandler = (title) => {
    if (title === how_to_test) {
      navigate(HOW_TO_TEST_RIGHT_EXTENSION + `${searchParams}`);
    }
  };
  const videoPickHandler = () => {
    sessionStorage.setItem("fromUpload", JSON.stringify(getTestDetails));
    videoRef.current.click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      dispatch(setVideoFile(file));
      setShowItem(false);
    }
  };

  const skipHandler = () => {
    navigate(USER_LIST + `${searchParams}`);
    sessionStorage.setItem("romStatus", "");
    sessionStorage.setItem("romReportId", "");
  };

  return (
    <>
      <UserDetailsHeader>
        <div className="rom-block">
          <Typography className="title">{getInfo?.moduleName}</Typography>
          {showItem ? (
            <div className="rom-test-info-wrapper">
              <div className="rom-test-item-block">
                <Typography className="leg-title">{right_leg}</Typography>
                <Typography className="leg">2: {knee_extension}</Typography>
                <img
                  src={romRightExtension}
                  alt="rom-leftFlexion"
                  className="test-img"
                />
                <Typography className="test-description">
                  {right_extension_desc}
                </Typography>
                {itemList.map((item, index) => {
                  return (
                    <div
                      className="item-wrapper"
                      key={index}
                      onClick={() => videoHandler(item?.title)}
                    >
                      <div className="item-name">
                        <img src={item.icon} alt="info" className="img" />
                        <Typography>{item.title}</Typography>
                      </div>
                      <div className="arrow">
                        <img src={forwardArrow} alt="forwardArrow" />
                      </div>
                    </div>
                  );
                })}
                <input
                  type="file"
                  accept="video/mp4"
                  ref={videoRef}
                  className="video-upload"
                  onChange={handleFileChange}
                />
                <div className="important-text">
                  <Typography
                    className="sub-info"
                    component="div"
                    dangerouslySetInnerHTML={{ __html: testUploadAlert }}
                  />
                </div>
                <div className="record-upload-btn">
                  <button className="button" onClick={() => videoPickHandler()}>
                    {record_upload}
                  </button>
                </div>
                {statusOfTestTaken === "success" && (
                  <button className="skip-btn" onClick={() => skipHandler()}>
                    {skip}
                  </button>
                )}
              </div>
            </div>
          ) : (
            <FileUpload styleChange={true} />
          )}
        </div>
      </UserDetailsHeader>
    </>
  );
};

export default ROMRightExtension;
